
    import { Component } from 'vue-property-decorator';
    import Util from '@/lib/util';
    import ListBase from '@/lib/listbase';
    import PageRequest from '@/store/entities/page-request';
    import ListView from '@/components/helper/list-view.vue';
    import FormBase from '@/components/helper/form-base.vue';
    //import WorkshopinfoForm from './workshopinfo-form.vue';
    import ImportChanges from './import-changes.vue';
    import WorkshopInfoReport from '@/views/reports/general/workshop-infos.vue';

    class PageWorkshopInfoRequest extends PageRequest {
        manufacturer: number = null;
        function: number = null;
        customer: string = null;
        dealer: number = null;
    }

    @Component({
        components: { ListView, FormBase, ImportChanges, WorkshopInfoReport },
        watch: {
            dealer: function (val) {
                (this as any).getpage();
            },
            manufacturer: function (val) {
                (this as any).getpage();
            }
        }
    })
    export default class WorkshopInfos extends ListBase {
        entity: string = 'workshopinfo';
        pagerequest: PageWorkshopInfoRequest = new PageWorkshopInfoRequest();
        filterForm: boolean = true;
        showImport: boolean = false;
        views: Array<any> = [{ code: "stats", title: "Ver Reporte", icon: "bar_chart" }];

        filterItems = [
            this.gItem({ type: 'object', prop: 'function', label: 'Funcion Principal', generalType: 'FUNCTIONS', hideDetails: true, onchange: this.getpage, size: 4 }),
            this.gItem({ type: 'text', prop: 'customer', label: 'Buscar por Nombre o Apellido', hideDetails: true, onchange: this.getpage, size: 4 }),
            this.gItem({ type: 'spacer', size: 4 }),
        ]

        function_id: number;
        birthdate: string;

        columns = [
            this.gCol('employee.code', 'DNI', 'text'),
            this.gCol('firstname', 'Apellidos', 'text'),
            this.gCol('lastname', 'Nombres', 'text'),
            this.gCol('manufacturer.name', 'Marca', 'text'),
            this.gCol('dealer.name', 'Empresa', 'text'),
            this.gCol('city', 'Ciudad', 'text'),
            this.gColO({ type: 'text', value: 'function_id', text: 'Funcion principal', generalType: true }),
            this.gCol('phone', 'Telefono', 'text'),
            this.gCol('movil', 'Movil', 'text'),
            this.gCol('email', 'Direccion de e-mail', 'text'),
            this.gCol('birthdate', 'Fecha de nacimiento', 'date'),
        ]

        get dealer() {
            return this.$store.state.app.dealer;
        }
        get manufacturer() {
            return this.$store.state.app.manufacturer;
        }
        get checking() {
            return this.$store.state.dashboard.loading;
        }
        get isDealer() {
            return Util.abp.session.isDealer();
        }

        async getpage() {
            this.pagerequest.dealer = this.dealer;
            this.pagerequest.manufacturer = this.manufacturer;
            let list: any = this.$refs.listView
            if (list != undefined) {
                await list.getpage();
            }

            let report: any = this.$refs.report
            if (report != undefined) {
                await report.getpage();
            }
        }

        mounted() {
        }

        created() {
            this.pagerequest.dealer = this.dealer;
            this.pagerequest.manufacturer = this.manufacturer;
        }
    }
